<template>
  <a href="#" @click.prevent="back"><i class="fas fa-chevron-left"></i> Terug</a>
<!--  <router-link to="/" @click.prevent="back"><i class="fas fa-chevron-left"></i> Terug</router-link>-->
</template>

<script>
export default {
  name: "ButtonBack",
  methods: {
    hasHistory () {
      return window.history.length > 2;
    },
    back() {
      //emit event for when parent component needs to do something when back is clicked
      this.$emit("clicked");

      if (this.hasHistory()) {
        this.$router.back();
      }
      else {
        this.$router.push({name: 'home'});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    //background-color: $primary-blue;
    color: $font-dark;
    font-size: $body-text-size;
    font-weight: bold;
    text-align: start;
    margin-top: 40px;
    margin-left: 25px;
    text-decoration: none;
    i {
      color: $primary-blue;
      margin-right: 20px;
    }
  }
</style>